<script lang="ts" setup>
import { useLocale } from '@composables/useLocale'

const { t } = useLocale()
</script>

<template>
  <slot></slot>
  <section
    data-test="footer"
    class="flex h-[calc(400*var(--vh))] w-full flex-row justify-center gap-[calc(72*var(--vw))]"
  >
    <!-- Identification user container -->
    <slot name="identification"></slot>

    <div class="gap-vh-16 flex h-full w-[calc(480*var(--vw))] flex-col">
      <!-- Primary button section -->
      <slot name="primary-actions"></slot>

      <!-- Secondary button section -->
      <slot name="secondary-actions"></slot>
      <!-- Kcal disclaimer -->
      <p class="text-xsmall mb-14 w-fit self-end">
        {{ t('imagenes_de_caracter_ilustrativo') }}
      </p>
    </div>
  </section>
</template>
